if (!customElements.get('sa-be-present-video-stories')) {
  customElements.define(
    'sa-be-present-video-stories',
    class SaBePresentVideoStories extends HTMLElement {
      constructor() {
        super();
        this.boundOnClick = this.onClick.bind(this);
        this.boundOnKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.removeEventListener('click', this.boundOnClick);
        this.addEventListener('click', this.boundOnClick);
        this.removeEventListener('keydown', this.boundOnKeydown);
        this.addEventListener('keydown', this.boundOnKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundOnClick);
        this.removeEventListener('keydown', this.boundOnKeydown);
        this.querySelectorAll('[data-sa-bpvs-video-card].is-playing').forEach((card) => this.stopCard(card));
      }

      getCardFromTarget(target) {
        if (!target) return null;
        const trigger = target.closest('[data-sa-bpvs-video-trigger]');
        if (trigger) return trigger.closest('[data-sa-bpvs-video-card]');
        return target.matches('[data-sa-bpvs-video-card]') ? target : null;
      }

      onClick(event) {
        const card = this.getCardFromTarget(event.target);
        if (!card || !this.contains(card)) return;
        this.toggleCard(card);
      }

      onKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = this.getCardFromTarget(event.target);
        if (!card || !this.contains(card)) return;
        event.preventDefault();
        this.toggleCard(card);
      }

      toggleCard(card) {
        if (card.classList.contains('is-playing')) {
          this.stopCard(card);
          return;
        }

        this.querySelectorAll('[data-sa-bpvs-video-card].is-playing').forEach((activeCard) => {
          if (activeCard !== card) this.stopCard(activeCard);
        });
        this.playCard(card);
      }

      playCard(card) {
        const player = card.querySelector('[data-sa-bpvs-video-player]');
        if (!player) return;

        const video = player.querySelector('video');
        if (video) {
          const source = video.dataset.src;
          if (source && !video.getAttribute('src')) {
            video.setAttribute('src', source);
            video.load();
          }
          video.controls = true;
          card.classList.add('is-playing');
          video.play().catch(() => {
            card.classList.remove('is-playing');
          });
          video.addEventListener(
            'ended',
            () => {
              card.classList.remove('is-playing');
            },
            { once: true }
          );
          return;
        }

        const iframe = player.querySelector('iframe');
        if (iframe) {
          const embedSrc = iframe.dataset.embedSrc;
          if (!embedSrc) return;
          iframe.src = this.withAutoplay(embedSrc);
          card.classList.add('is-playing');
        }
      }

      stopCard(card) {
        const player = card.querySelector('[data-sa-bpvs-video-player]');
        if (!player) return;

        const video = player.querySelector('video');
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.controls = false;
        }

        const iframe = player.querySelector('iframe');
        if (iframe) {
          iframe.removeAttribute('src');
        }

        card.classList.remove('is-playing');
      }

      withAutoplay(url) {
        if (!url) return '';
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      }
    }
  );
}
